var React = require('react');

function BorderAll (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 288H256v128h-64V288H64v-64h128V96h64v128h128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 384H64V96h320z","className":"fa-primary","key":2})]);
}

BorderAll.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = BorderAll;

BorderAll.default = BorderAll;
